 const treeUtil=
{
   buildTree(list, rootKey, parentKey, idKey) {
     var aa = []
    if (rootKey == undefined) {
      rootKey = null
    }else{
      if(rootKey.indexOf("0")!=-1) {
        aa.push("0")
      }
      if(rootKey.indexOf("1")!=-1) {
        aa.push("6")
      }
      if(rootKey.indexOf("2")!=-1) {
        aa.push("7")
      }

    }
    if (parentKey == undefined) {
      parentKey = 'parentId'
    }
    if (idKey == undefined) {
      idKey = 'id'
    }
    // console.log("listlistlist",list)
    let tree = []
     for (let item of list){
       if(aa.length > 0) {
         // for(let index in aa) {
         //   if (item[parentKey] == aa[index] || item[parentKey] == null) {
         if(item[parentKey] == null) {
           tree.push(item)
         }
           // }
         // }
       }else{
         if (item[parentKey] == null) {
           tree.push(item)
         }
       }


     }
    if (tree.length == 0) {
      return list
    }
    let parents = tree
    let childrens = []
    while (parents.length > 0) {
      for(let i of parents){
        for(let j of list){
          if (j[parentKey] == i[idKey]) {
            if (!i.children) {
              i.children = []
            }
            i.children.push(j)
            childrens.push(j)
          }
        }
      }
      parents = childrens;
      childrens = []
    }
    return tree
  }
}
export default  treeUtil
